export default [
  {
    key: 'index',
    label:'id',

  },
  {
    key: 'owner_name',
    label: 'owner',
    sortable: true
  },
  {
    key: 'contract_name',
    label: 'contract',
    sortable: true
  },
  {
    key: 'device_name',
    label: 'device',
    sortable: true
  },
  {
    key: 'device_plate',
    label: 'device plate',
    sortable: true
  },
  {
    key: 'day',
    label: 'day',
    sortable: true
  },
  {
    key: 'shift_start',
    label:'shift start',
    sortable: false
  },
  {
    key: 'shift_end',
    label: 'shift end',
    sortable: false
  },

  {
    key: 'actual_camp_leave',
    label: 'camp leave',
    sortable: false
  },

  {
    key: 'actual_camp_back',
    label: 'camp back',
    sortable: false
  },

  {
    key: 'ignition_on_time',
    label: 'ignition on',
    sortable: false
  },

  {
    key: 'ignition_off_time',
    label: 'ignition off',
    sortable: false
  },

  {
    key: 'planned_total_distance',
    label: 'planned distance',
    sortable: false
  },

  {
    key: 'actual_swept_distance',
    label: 'total swept',
    sortable: false
  },
  {
    key: 'swept_in_plan',
    label: 'swept In Plan',
    sortable: false
  },
  {
    key: 'swept_out_plan',
    label: 'swept Out Plan',
    sortable: false
  },

  {
    key: 'performance_percentage',
    label: 'percent',
    sortable: false
  },
]